import Vue from 'vue'
import 'jquery'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './api/axios'

import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/css/styles.scss'
Vue.use(iView);

Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


axios
  .get("/api/userstate")
  .then(response => {
    if(response.data.status){
      store.commit('SET_USER_LOGIN_INFO',response.data.data)
    }
    var vue = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  })
  .catch(function(error) {
      console.log(error);
  });


